<template>
    <div>
        <!--  BEGIN NAVBAR  -->
        <Header v-if="!layoutState.isAuth"></Header>
        <!--  END NAVBAR  -->

        <!--  BEGIN MAIN CONTAINER  -->
        <div class="main-container" id="container" :class="containerClasses">
            <!--  BEGIN OVERLAY  -->
            <div v-if="!layoutState.isAuth" class="overlay" :class="{ show: !layoutState.showSidebar }" @click="toggleSidebar"></div>
            <div v-if="!layoutState.isAuth" class="search-overlay" :class="{ show: layoutState.showSearch }" @click="toggleSearch"></div>
            <!-- END OVERLAY -->

            <!--  BEGIN SIDEBAR  -->
            <Sidebar v-if="!layoutState.isAuth"></Sidebar>
            <!--  END SIDEBAR  -->

            <!-- Toggle flutuante na separação sidebar / conteúdo -->
            <button
                v-if="!layoutState.isAuth"
                type="button"
                class="sidebar-edge-toggle"
                :class="{ 'sidebar-edge-toggle--closed': !layoutState.isSidebarVisuallyOpen }"
                :title="layoutState.isSidebarVisuallyOpen ? 'Recolher menu' : 'Abrir menu'"
                :aria-label="layoutState.isSidebarVisuallyOpen ? 'Recolher menu' : 'Abrir menu'"
                @click="toggleSidebar"
            >
                <!-- Aberto: seta para esquerda (recolher) / Fechado: seta para direita (abrir) -->
                <svg
                    v-if="layoutState.isSidebarVisuallyOpen"
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                >
                    <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
                <svg
                    v-else
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                >
                    <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
            </button>

            <!--  BEGIN CONTENT AREA  -->
            <div id="content" class="main-content" :class="layoutState.isAuth ? 'auth-layout' : ''">
                <div
                    v-if="!layoutState.isAuth"
                    class="main-content-toolbar"
                >
                    <div
                        id="breadcrumb"
                        class="vue-portal-target main-content-toolbar__breadcrumb d-flex flex-grow-1 align-items-center min-w-0"
                    ></div>
                </div>
                <router-view />
            </div>
            <!--  END CONTENT AREA  -->

            <!-- BEGIN APP SETTING LAUNCHER -->
            <app-settings v-if="!layoutState.isAuth" />
            <!-- END APP SETTING LAUNCHER -->

            <!-- BEGIN NOTIFICATION TOASTS -->
            <NotificationToast />
            <!-- END NOTIFICATION TOASTS -->

            <LegalGraceBanner />
        </div>
    </div>
</template>

<script setup>
    import { computed } from 'vue';
    import { useLayout } from '@/composables/useLayout';
    import Header from "../components/layout/header.vue";
    import Sidebar from "../components/layout/sidebar.vue";
    import appSettings from "../components/app-settings.vue";
    import NotificationToast from "../components/notifications/NotificationToast.vue";
    import LegalGraceBanner from "../components/legal/LegalGraceBanner.vue";

    const { layoutState, toggleSidebar, toggleSearch } = useLayout();

    const containerClasses = computed(() => [
        !layoutState.value.showSidebar ? 'sidebar-closed sbar-open' : '',
        layoutState.value.isSidebarVisuallyOpen ? 'sidebar-visually-open' : 'sidebar-visually-closed',
        layoutState.value.sidebarSkipTransition ? 'sidebar-instant' : '',
        layoutState.value.menuStyle === 'collapsible-vertical' ? 'collapsible-vertical-mobile' : '',
        layoutState.value.isAuth ? 'main-container-auth' : ''
    ]);

    
</script>
